import { Component, Input } from "@angular/core";

import { STRING } from "../../../constants/string";

export type MedLinkModeType = "bottom" | "left" | "top" | "right";

@Component({
  selector: "med-link[url]",
  templateUrl: "./med-link.component.html",
  styleUrls: ["./med-link.component.scss"],
})
export class MedLinkComponent {
  @Input() url!: string;
  @Input() classLink = "";
  @Input() target = "_self";
  @Input() disabled = false;
  @Input() urlPrefix?: string | number;
  @Input() mode: MedLinkModeType = "bottom";

  get classList(): string {
    const disabled = this.disabled ? "disabled" : "";
    return [this.classLink, this.mode, disabled].join(" ");
  }

  get link(): string {
    const prefix = this.urlPrefix ? `/${this.urlPrefix}` : STRING.EMPTY;
    return [prefix, this.url].join(STRING.EMPTY);
  }
}
